import Link from "next/link";

export default function CtaContact() {
  return (
    <div className={`mt-[5rem] sm:mt-0`} data-aos="fade-up">
      <div className={`px-6 pb-24 sm:px-6 sm:py-32 lg:px-8 `}>
        <div className="mx-auto max-w-7xl text-center">
          <h2 className="text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl">
            Ready to improve your process?
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg/8 text-pretty text-gray-600">
            Whether you're planning a new system or optimizing an existing one,
            our team can help you design the right automation solution for your
            production goals.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              href="/contact-us"
              className="rounded-md bg-blue-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-blue-600
                         focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 duration-500"
            >
              Talk to our team
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
